import { useState, useEffect, useRef, useContext } from "react";
import { Box, Spinner, Text } from "grommet";
import { useLocation } from "react-router-dom";
import { useFetch } from "use-http";
import { useNavigate } from "react-router-dom";
import HomePageNav from "../components/Base components/HomePageNav";
import SheetHeader from "../components/Base components/SheetHeader";
import { getDBURL, updateStateHandler, convertDateToDisplayformat, correctTimeZone, sheetStatus, getKeyByValue, nearestInteger } from "../components/Utils/Utils";
import PostHarvestEvaluation from "../components/PostHarvest/PostHarvestEvaluation";
import Notification from "../components/Base components/Notification";
import { UserContext } from "../App";

import Postharvest1 from "../components/PostHarvest/PostHarvest1";
import PostHarvest2 from "../components/PostHarvest/PostHarvest2";
import PostHarvest3 from "../components/PostHarvest/PostHarvest3";

const PostHarvestPage = (props) => {
    const currentUser = useContext(UserContext);
    const { state } = useLocation();
    const [editMode, setEditMode] = useState(state.editMode);
    // const [plantInfo, setPlantInfo] = useState(state.plantInfo);
    const station = state.station;
    const [disable, setDisable] = useState(state.disable);  
    const editYear = useState(state.editYear);
    const [loadExisting, setLoadExisting] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [grade, setGrade] = useState(0);
    const [evProgress, setEvProgress] = useState(0);
    const [fieldEdited, setFieldEdited] = useState(false); // save only if at least one of the input fields on the screen has been edited
    const navigate = useNavigate();
    const [valuesLoaded, setValuesLoaded] = useState(false);
    const [success, setSuccess] = useState(false);
    const [navigateAfterSuccess, setNavigateAfterSuccess] = useState(false);
    const [showError, setShowError] = useState(false);
    const [notificationMessage, setNotificationMessage] = useState("");
    const [hasEdit, setHasEdit] = useState(false);
    const { get, post, loading } = useFetch(getDBURL());
    const changeCount = useRef(0);

    let existingPostharvestID = state.PostharvestID;

    const getStateValues=(values)=>{
        // console.log("values:  ", values);
        // console.log("existingPostharvestID:  ", existingPostharvestID);
        const isNull = values === null;

        return {
            PostHarvest_ID: existingPostharvestID,
            StationId: station.Id,   
            // VineID: plantInfo.PlantUID,
            CreateDate: isNull ? new Date() : values.CreateDate,
            CreatedBy: isNull ? currentUser.email : values.CreatedBy,
            Year: isNull ? new Date().getFullYear() : values.Year,
            Grade: isNull ? 0 : values.Grade,
            StatusID: isNull ? getKeyByValue(sheetStatus,'In Progress') : values.StatusID,
            BerryAttachment: isNull ? null : values.BerryAttachment,
            SkinTexture: isNull ? null : values.SkinTexture,
            BerryTexture: isNull ? null : values.BerryTexture,
            EatingQuality: isNull ? null : values.EatingQuality,
            BerryColorW: isNull?null:values.BerryColorWhite,
            BerryColorR: isNull?null:values.BerryColorRed,
            FirmBerries: isNull?null:values.FirmBerries,
            Astringency: isNull ? null : values.Astringency,
            AvgBrix: isNull ? 0 : values.AvgBrix,
            AvgRatio: isNull ? 0 : values.AvgSugarAcidRatio,
            RachisDehydration: isNull?null:values.RachisDehydration,
            BerryWrinkle: isNull?null:values.BerryWrinkle,
            BerrySplit: isNull?null:values.BerrySplit,
            NeckCrack: isNull?null:values.NeckCrack,
            Decay: isNull ? null : values.Decay,
            ShelfLife: isNull ? null : values.ShelfLife,
            RecStoragePeriod: isNull?"":values.RecStoragePeriod,
            PackingMethod: isNull ? "" : values.PackingMethod,
            Notes: isNull ? null : values.Notes,
            HalvedBerry1: isNull ? "" : values.HalvedBerryImg1,
            HalvedBerry2: isNull ? "" : values.HalvedBerryImg2,
            Variety: isNull ? null : values.Variety,
            FreeImgText: isNull ? "" : values.FreeImgText,
            FreeImg: isNull ? "" : values.FreeImg,
            EvaluationProgress: isNull ? 0 : values.EvaluationProgress,
            UpdatedAt: isNull ? null :  values.UpdatedAt,
            UpdatedBy: isNull ? null :  values.UpdatedBy,
            FinishedAt: isNull ? null :  values.FinishedAt,
            FinishedBy:  isNull ? null : values.FinishedBy, 
        };
    };

    const [postHarvestValues, setPostHarvestValues] = useState(getStateValues(null));

    useEffect(() => {
        if (editMode) {
            setLoadExisting(true);
            loadPostHarvestHandler();
            setFieldEdited(false);
        }
        else {
           setValuesLoaded(true);
           setLoadExisting(false);          
        }
    }, []);

    useEffect(() => {
        setShowError(false);
        setSuccess(false);
        setNotificationMessage("");

        if ((editMode && changeCount.current === 4) 
            || (!editMode && changeCount.current===2)) 
        {
            setHasEdit(true);
        } else{
            changeCount.current++;
        }   
    }, [postHarvestValues]);

    // console.log("postHarvestValues:  ", postHarvestValues);

    const navigateToEvalSheet = () => {
        setNavigateAfterSuccess(false); // reset flag
        // console.log(' submit  state.plantInfo :  ', state.plantInfo );
        // console.log(' submit   state.selectedField:  ',  state.selectedField);
        // console.log(' submit   state.station:  ',  station);
        navigate('/eval-sheet', { 
            state:{
                fromAnotherScreen: true, 
                newExist: "ExistingEvaluation", 
                chosenOption: "Stations",
                selectedField  : state.selectedField,
                selectedStation: station,
                plantInfo: null,         // for EvaluationSheet screen 
                activeStationsList: state.activeStationsList,
                chosenVineInfo: null,    // for ExistingEvaluation screen               
                showScionOnField: false,
            }  
        });
    }; 

    useEffect(() => {
        if (postHarvestValues.Grade !== grade) {
            updateStateHandler(setPostHarvestValues, "Grade", grade);
        }
    }, [grade]);

 
    useEffect(() => {
        if (postHarvestValues.EvaluationProgress !== evProgress) {
            updateStateHandler(setPostHarvestValues, "EvaluationProgress", evProgress);
        }       
    }, [evProgress]);

    useEffect(() => {
        if (fieldEdited && postHarvestValues.PostHarvest_ID !== null) {
            updateStateHandler(setPostHarvestValues, "UpdatedAt", correctTimeZone(new Date()));
            updateStateHandler(setPostHarvestValues, "UpdatedBy", currentUser.email);    
        } 
    }, [fieldEdited]);   

    
    const updateGrade = (prevOption, newOption) => {
        setGrade(grade - prevOption.grade + newOption.grade);

        if (prevOption.index === 0 && newOption.index !== 0)
            setEvProgress(evProgress + 5.56);
        else if (prevOption.index !== 0 && newOption.index === 0)
            setEvProgress(evProgress - 5.56);

        //  console.log("grade:" + (grade - prevOption.grade + newOption.grade));
        //  console.log("evProgress:", evProgress);
    };
    //console.log("evProgress:", evProgress);
    const updateProgressByCheck = (prevOption, newOption) => {
        if (prevOption === newOption)
            return;

        if (prevOption === 0 && newOption > 0)
            setEvProgress(evProgress + 5.56);
        else if (prevOption > 0 && newOption === 0)
            setEvProgress(evProgress - 5.56);

        // console.log("evProgress:", evProgress);
    }; 
    async function loadPostHarvestHandler() {
        try {
            // console.log("existingPostharvestID:  "+ existingPostharvestID);
            const data = await get("/loadPostHarvestValues/postHarvest_ID=" + existingPostharvestID + "/dt=" + Date.now())
            // console.log("Postharvest: >> ", data[0]);
            if( data !== undefined && data.length > 0) {
                setPostHarvestValues(getStateValues(data[0]));                 
                setGrade(data[0].Grade);
                setEvProgress(data[0].EvaluationProgress);
                setValuesLoaded(true);
            }
        }
        catch(error) {
            console.log('in loadPostHarvestHandler error: ', error);
        }  
    }

    async function savePostHarvestHandler() {
        setHasEdit(false);

        // create or update depending on edit mode:
        // console.log("postHarvestValues:  ", postHarvestValues);
        if (editMode === true) {
            try {
                changeCount.current = 4;
                await post("/updatePostharvest", postHarvestValues);
                // console.log('res in saveTreatmentHandler f-n updating >> ', res);
                setSuccess(true);
                // setNotificationMessage(sheetName + " sheet saved successfully.");
                setFieldEdited(false);
                return true;
            }
            catch(error)
            {
                console.log('Error In savePostHarvestHandler f-n on update: ', error.message);
                setShowError(true);
                setNotificationMessage(error.message);
                return false;
            };    
        } else {
            changeCount.current = 2;
            try {
                const newPostHarvestId = await post("/createPostharvest", postHarvestValues);           
                // console.log('newPostHarvestId >> ', newPostHarvestId);
                if (newPostHarvestId !== null)
                { 
                    updateStateHandler(setPostHarvestValues, "PostHarvest_ID", newPostHarvestId); 
                    existingPostharvestID = newPostHarvestId;
                    setSuccess(true);
                    return true;                    
                }
            }
            catch (error) {
                console.error('Error In savePostHarvestHandler f-n on create: ', error.message);
                setShowError(true);
                setNotificationMessage(error.message);
                return false;
            }
            setEditMode(true);
        }
    }

    const close=()=>{
        setSuccess(false);
    }

    return (
        <Box
            justify="between"       
            width="90%"
            margin="auto" >
            <Box 
                style={{ 
                    position: 'fixed',
                    width: '90%',
                    top: 0,
                    left: '45%',
                    transform: 'translate(-45%)',
                    zIndex: 10,
                //    sticky: "scrollUp"
                }}
            >
                <Box background="black" pad={{vertical: "xsmall"}} width="100%" direction="row" justify="between" align="center"  margin="auto"        >
                    <Box pad={{top: "10px"}} >
                        <HomePageNav 
                            selectedField = {state.selectedField}
                            station = {state.station}
                            plantInfo={null} 
                            hasEdit = {hasEdit} 
                            activeStationsList={state.activeStationsList}            
                        />
                    </Box>   
                    <Box direction="row" justify="end" align="center" pad={{horizontal: "20px"}}>
                        <Text size="medium" weight="bold" color="#EEEEEE" >Hi {currentUser.email} </Text>
                    </Box>             
                </Box>
                <Box>
                    <SheetHeader
                        station={state.station}
                        sheetName={'PostHarvest'}
                        setSheetValues={setPostHarvestValues}
                        sheetDate={postHarvestValues.CreateDate === undefined ? convertDateToDisplayformat(new Date()) : convertDateToDisplayformat(postHarvestValues.CreateDate)}
                        editMode={editMode} // true for existing evaluation and false only for new evaluation
                        isStation={true}
                    />
                </Box>
            </Box>

            <Box>
            {!valuesLoaded ? (
                <Box align="center" direction="row" gap="small" pad="small">
                    <Spinner /> <Text>Loading...</Text>
                </Box>
            ) : (
                <>
               {showError && (
                    <Notification
                    status="critical"
                    message="ERROR SAVING POSTHARVEST EVALUATION."
                    onClose={() => setShowError(false)}
                  />
                )}
                {success && (
                    <Notification
                    status="normal"
                    message={"POSTHARVEST SAVED SUCCESSFULLY."}
                    onClose={() => {
                        setSuccess(false);
                        if(navigateAfterSuccess)// <-- trigger navigation here
                            navigateToEvalSheet(true); 
                      }}
                  />   
                )}   
                {/* {loading && (
                    <Box align="center" direction="row" gap="small" pad="small">
                    <Spinner /> <Text>Loading...</Text>
                    </Box>
                )} */}
                <PostHarvestEvaluation
                    postHarvestValues={postHarvestValues}
                    setPostHarvestValues={setPostHarvestValues}
                    savePostHarvestHandler={savePostHarvestHandler}
                    updateGrade={updateGrade}
                    updateProgressByCheck={updateProgressByCheck}
        //            setGrade={setGrade}
                    fieldEdited={fieldEdited}
                    setFieldEdited={setFieldEdited}
                    setSuccess={setSuccess}
                    setNavigateAfterSuccess={setNavigateAfterSuccess}
                    setShowError={setShowError}
                    disable={disable}
        //            plantInfo={plantInfo}
        //            setEditMode={setEditMode}
        //            sheetName={sheetName}   
                    grade={grade}    
                />
                    </>
                )}
        </Box>
    </Box>
    );
};

export default PostHarvestPage;
